// Loading component with better UX
import React from "react";

const LoadingSpinner = ({ message }) => (
    <div className="loading-spinner">
        <div className="spinner"></div>
        <p>{message}</p>
    </div>
);

export default LoadingSpinner;
